import { Language } from "../domain/Language";
export function isUpperCase(str) {
    return str.toLowerCase() != str;
}
export function toLocaleAwareUpperCase(char, lang) {
    if (char == "ß")
        return "ẞ";
    if (lang == Language.Ka)
        return char;
    return char.toUpperCase();
}
export function isWhitespaceOrEmpty(char) {
    return isWhitespace(char) || isEmpty(char);
}
function isWhitespace(char) {
    return /\s/.test(char);
}
function isEmpty(char) {
    return char == "";
}
